import { render, staticRenderFns } from "./Seckill.vue?vue&type=template&id=36dc7882&"
import script from "./Seckill.vue?vue&type=script&lang=js&"
export * from "./Seckill.vue?vue&type=script&lang=js&"
import style0 from "./Seckill.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/yx-web-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36dc7882')) {
      api.createRecord('36dc7882', component.options)
    } else {
      api.reload('36dc7882', component.options)
    }
    module.hot.accept("./Seckill.vue?vue&type=template&id=36dc7882&", function () {
      api.rerender('36dc7882', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Activity/Children/StatisticsChildren/Seckill.vue"
export default component.exports